import { DisabledPrompt, useBCMSContext, useParams, useRoute } from "@bcm-dev/bcms-vite";
import FormContainer, { FormButtonContainer, FormRow } from "components/shared/containers/FormContainer";
import MainContentContainer, { MainContentHeader } from "components/shared/containers/MainContentContainer";
import AlertsToggleView from "components/shared/views/BaseToggleView/components/AlertsToggleView";
import ControlToggleView from "components/shared/views/BaseToggleView/components/ControlToggleView";
import { UICancelButton, UIPrimaryButton } from "components/ui/UIButton";
import React, { useState } from "react";
import { SVGAsset } from "res";
import "./styles.css";
/**
 * @function MerchantAlertsPage
 * @return {React.Component}
 * @exported true
 * @description The main component for MerchantAlertsPage
 */

export default function MerchantAlertsPage(props) {
  const navigate = useRoute();
  const [ state, setState ] = useState(false);
  const globalController = useBCMSContext();
  const defaultCard =   globalController.state.branding.options.include_debit_chw23  !== "false" ? "0" : "1";
  const cardID = useParams().cardID ?? defaultCard;
  return (
    <div className="merchant-alerts-page">
      <MainContentContainer header={
        <MainContentHeader text="Merchant Alerts"/>
      }>
        <FormContainer>
          <AlertsToggleView onChange={setState} mainText="Enable Merchant Alerts" subText="Alert me for selected merchant types." className="hide-chevron-icon" />
          <FormRow>
            <MerchantAlertRow
             mainText="Department Store"
             subText="Clothing, office supplies, florists, auto dealers, home goods a…"
             expandedText="Clothing, office supplies, florists, auto dealers, home goods, and sports supplies. Purchases at department store merchants are denied if this Merchant Type is off."
             checked={ state } 
             dataPoint="Merchant_Controls_Department_Store"
             className={ !state ? "disabled" : "" }/>
           
          </FormRow>
          <FormRow>
            <ControlToggleView
            disabledArrow={true}
            checked={ state }
              mainText="Entertainment"
              subText="Theme parks, theatres, books, music, games, and sporting e..."
              className={ !state ? "disabled" : "" }
            />
          </FormRow>
          <FormRow>
            <ControlToggleView
            disabledArrow={true}
            checked={ state }
              mainText="Gas Station"
              subText="Filling stations, petroleum, and petroleum products. Purcha..."
              className={ !state ? "disabled" : "" }
            />
          </FormRow>
          <FormRow>
            <ControlToggleView
            disabledArrow={true}
            checked={ state }
              mainText="Grocery"
              subText="Supermarkets, bakeries, butchers, speciality markets, and c..."
              className={ !state ? "disabled" : "" }
            />
          </FormRow>
          <FormRow>
            <ControlToggleView
            disabledArrow={true}
            checked={ state }
              mainText="Household"
              subText="Utilities, contracted services, business services, courier servic..."
              className={ !state ? "disabled" : "" }
            />
          </FormRow>
          <FormRow>
            <ControlToggleView
            disabledArrow={true}
            checked={ state }
              mainText="Personal Care"
              subText="Drug stores, pharmacies, health services, medical services, a..."
              className={ !state ? "disabled" : "" }
            />
          </FormRow>
          <FormRow>
            <ControlToggleView
             disabledArrow={true}
             checked={ state }
              mainText="Restaurant"
              subText="Cafes, coffee, fast food, catering, and food trucks. Purchases..."
              className={ !state ? "disabled" : "" }
            />
          </FormRow>
          <FormRow>
            <ControlToggleView
            disabledArrow={true}
            checked={ state }
              mainText="Travel"
              subText="Drug stores, pharmacies, health services, medical services, a..."
              className={ !state ? "disabled" : "" }
            />
          </FormRow>
          <FormRow>
            <ControlToggleView
            disabledArrow={true}
            checked={ state }
              mainText="Age Restricted"
              subText="Liquor, nicotine, casinos, bars, dating and escort services, an..."
              className={ !state ? "disabled" : "" }
            />
          </FormRow>
          <FormRow>
            <ControlToggleView
            disabledArrow={true}
            checked={ state }
              mainText="Other"
              subText="Other cases where merchant types cannot be identified are..."
              className={ !state ? "disabled" : "" }
            />
          </FormRow>
          <FormButtonContainer>
            <DisabledPrompt>
              <UIPrimaryButton text="Apply" />
            </DisabledPrompt>
            <UICancelButton text="Cancel" onClick={ evt => navigate(-1) } />
          </FormButtonContainer>
        </FormContainer>
      </MainContentContainer>
    </div>
  );function MerchantAlertRow(props) {
    const nonExpanded = props.subText ?? "";
    const expanded = props.expandedText;
  
    const [ state, setState ] = useState(false);
    const toggle = evt => setState(!state);
  
    const icon = expanded === undefined
      ? <DisabledPrompt><SVGAsset id="RightChevronIcon" className="clickable chevron-icon" /></DisabledPrompt>
      : <SVGAsset id={ state ? "DownChevronIcon" : "RightChevronIcon" } onClick={ toggle } className="clickable chevron-icon" />
  
    const textToShow = state ? expanded : nonExpanded;
  
    return (
      <ControlToggleView
        { ...props }
        subText={ textToShow }
        icon={ icon } />
    );
  }
}